var Handlebars = require('/app/node_modules/handlebars/runtime.js');
module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    return "disabled=\"true\"";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\""
    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"block") : stack1), depth0))
    + "\">\n    <a cat-url=\"/login\" class=\""
    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"button") : stack1), depth0))
    + " "
    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"redirect") : stack1), depth0))
    + "\">\n        <span class=\""
    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"link") : stack1), depth0))
    + "\">Войти</span>\n    </a>\n\n    <div class=\""
    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"title") : stack1), depth0))
    + "\">\n        Восстановление пароля\n    </div>\n\n    <div class=\""
    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"description") : stack1), depth0))
    + "\">\n        На ваш адрес эл.почты будет отправлено письмо с инструкциями </br>\n        по восстановлению пароля\n    </div>\n\n    <div class=\""
    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"inputGroup") : stack1), depth0))
    + "\">\n        <cat-text-email id=\"text-email\" path=\"restore.form.email\" error-path=\"restore.error.email\"></cat-text-email>\n    </div>\n\n    <cat-error></cat-error>\n\n    <button class=\""
    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"submit") : stack1), depth0))
    + "\" "
    + ((stack1 = lookupProperty(helpers,"unless").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"isEnabled") : depth0),{"name":"unless","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":21,"column":35},"end":{"line":21,"column":82}}})) != null ? stack1 : "")
    + ">\n        Восстановить пароль\n    </button>\n</div>\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./components/auth/restore/template.hbs
// module id = 929
// module chunks = 0